<ion-backdrop *ngIf="showBackdrop" [visible]="true"></ion-backdrop>
<ion-toolbar mode="md">
  <ion-buttons slot="start" class="back-button">
    <button nbButton ghost (click)="dismiss()" size="large" class="px-2">
      <nb-icon icon="arrow-ios-back-outline"></nb-icon>
    </button>
    <profile-avatars *ngIf="!isLoading; else skeletonAvatar" (click)="editPerson()"
      [team]="person?.picture"></profile-avatars>
    <ng-template #skeletonAvatar>
      <div class="skeleton-avatar"></div>
    </ng-template>
  </ion-buttons>
  <ion-title *ngIf="!isLoading; else skeletonTitle" (click)="editPerson()">
    {{ person?.firstName }} {{ person?.lastName }}
  </ion-title>
  <ng-template #skeletonTitle>
    <div class="skeleton-title"></div>
  </ng-template>
  <ion-buttons slot="end">
    <button *ngIf="pendingChanges && !isLoading" (click)="savePerson()" nbButton outline shape="round" status="basic"
      class="font-weight-normal mr-1">
      Save
    </button>
  </ion-buttons>
</ion-toolbar>

<ion-content>
  <div *ngIf="isLoading; else content">
    <div class="skeleton-settings"></div>
    <div class="skeleton-chart"></div>
    <div class="skeleton-connection-list">
      <div class="skeleton-connection-item" *ngFor="let i of [1,2,3,4,5,6,7,8,9,10]">
        <div class="skeleton-bullet"></div>
        <div class="skeleton-content">
          <div class="skeleton-title"></div>
          <div class="skeleton-date"></div>
        </div>
      </div>
    </div>
  </div>
  <ng-template #content>
    <ion-refresher slot="fixed" (ionRefresh)="handleRefresh($event)">
      <ion-refresher-content></ion-refresher-content>
    </ion-refresher>

    <div class="settings">
      <button fullWidth nbButton (click)="changeCircle(person?.circle)" shape="round" size="small" status="basic"
        class="mx-2">
        {{ person?.circleName ?? 'Select Circle' }} <nb-icon icon="people-outline"></nb-icon>
      </button>
      <button fullWidth nbButton (click)="changeContactPeriod(person?.contactPeriod)" shape="round" size="small"
        status="basic" class="mx-0">
        {{ person?.contactPeriod ?? 'Select Period' }} <nb-icon icon="calendar-outline"></nb-icon>
      </button>
      <button fullWidth nbButton id="open-date-modal" shape="round" size="small" status="basic" class="mx-2">
        {{ (person?.dob | date: 'LLL d') ?? 'DOB' }} <nb-icon icon="gift-outline"></nb-icon>
      </button>
    </div>

    <swipe-nav (buttonClicked)="buttonClicked($event)" (tabChange)="goToTab($event)" [currentTab]="activeTab"
      [tabs]="nav.tabs" class="mt-3"></swipe-nav>
    <div class="divider mx-4 py-1"></div>
    <swipe-tabs [selectedTabIndex]="activeTab" (currentTabChange)="setCurrentTab($event)" class="pb-5">
      <ion-slide>
        <section class="full">
          <div class="chart-container">
            <div *ngIf="!reportsDataAvailable" class="no-data-overlay">
              <p>No Data Available</p>
            </div>
            <div class="chart-header">
              <nb-select [(ngModel)]="selectedTimeRange" (ngModelChange)="onTimeRangeChange()" size="small"
                shape="semi-round" class="time-range-select">
                <nb-option *ngFor="let range of timeRanges" [value]="range.value">{{ range.label }}</nb-option>
              </nb-select>
            </div>
            <div echarts [options]="chartOption" class="connection-chart"></div>
          </div>
          <connection-list *ngIf="!isLoading" [connections]="person?.connections" [person]="person?.documentId"
            (refresh)="refreshConnections($event)"></connection-list>
          <div class="w-100 text-center d-flex flex-column ion-justify-content-center ion-align-items-center my-5">
            <img src="../../../assets/logo.png" height="125px" width="auto" style="height: 7.5rem">
          </div>
        </section>
      </ion-slide>
      <ion-slide>
        <section class="full chat">
          <div class="w-100">
            <div class="section-header mt-3 px-2">
              <h6 class="section-title">Notes</h6>
            </div>
            <textarea [formControl]="descriptionInput" type="text" class="mx-4 mb-4 p-2" rows="20" nbInput fullWidth
              fieldSize="giant" placeholder="Enter description or notes here.">
            </textarea>

            <!-- <div class="section-header">
            <h6 class="section-title">Notes <span class="section-alerts">(3)</span></h6>
          </div>
          <nb-chat>
            <nb-chat-message
              *ngFor="let msg of messages"
              [type]="msg?.type"
              [message]="msg?.text"
              [reply]="msg?.reply"
              [sender]="msg.user.name"
              [date]="msg.date"
              [files]="msg?.files"
              [quote]="msg?.quote"
              [latitude]="msg?.latitude"
              [longitude]="msg?.longitude"
              [avatar]="msg.user.avatar"
            >
            </nb-chat-message>
    
          </nb-chat> -->
          </div>

          <!-- <ion-fab vertical="bottom" horizontal="center">
            <nb-chat-form (send)="sendMessage($event)" [dropFiles]="false"> </nb-chat-form>
          </ion-fab> -->

        </section>
      </ion-slide>
      <ion-slide>
        <section class="full reports mb-5">
          <div class="w-100">
            <div class="reports-header">
              <nb-select [(ngModel)]="selectedTimeRange" (ngModelChange)="onTimeRangeChange()" size="small"
                shape="semi-round" class="time-range-select">
                <nb-option *ngFor="let range of timeRanges" [value]="range.value">{{range.label}}</nb-option>
              </nb-select>
            </div>

            <!-- No Data Available Overlay -->
            <div *ngIf="!reportsDataAvailable" class="no-data-overlay">
              <p>No Data Available</p>
            </div>

            <!-- Reports Content -->
            <div *ngIf="reportsDataAvailable" class="reports-container mb-5 pb-5">
              <div class="report-card">
                <h6 class="report-title">Connection Quality Over Time</h6>
                <div echarts [options]="reportsQualityChartOption" class="report-chart"></div>
              </div>
              <div class="report-card">
                <h6 class="report-title">Connection Medium</h6>
                <div echarts [options]="mediumChartOption" class="report-chart"></div>
              </div>
              <div class="report-card">
                <h6 class="report-title">Connection Initiator</h6>
                <div echarts [options]="initiatorChartOption" class="report-chart"></div>
              </div>
            </div>
          </div>
          <div class="w-100 text-center d-flex flex-column ion-justify-content-center ion-align-items-center my-5">
            <img src="../../../assets/logo.png" height="125px" width="auto" style="height: 7.5rem">
          </div>
        </section>
      </ion-slide>
    </swipe-tabs>

    <ion-modal trigger="open-date-modal" [breakpoints]="[0,0.4]" [initialBreakpoint]="0.4" [backdropBreakpoint]="0.2"
      (willDismiss)="onDismissDateModal($event)" [keepContentsMounted]="true">
      <ng-template>
        <ion-datetime id="datetime" presentation="date" [preferWheel]="true" [showDefaultButtons]="true" size="cover"
          [value]="person?.dob" (ionChange)="changeDOB($event)"></ion-datetime>
      </ng-template>
    </ion-modal>


    <ion-fab slot="fixed" vertical="bottom" horizontal="center" (click)="newConnection()">
      <button class="full-button page-button" nbButton size="giant" shape="round" outline status="primary"><nb-icon
          icon="plus-outline"></nb-icon>New Connection</button>
    </ion-fab>
  </ng-template>

</ion-content>